export default __webpack_public_path__ + "static/media/metaverse-icon-2.6210c8d4.png";